import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Button } from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import ContactPersonnelList from '../ContactPersonnelList';
import { getCommunityMembers, getExperts, getJournalists, mergeCommunityMembers } from '../contactsRequest';
import MergeIcon from '@mui/icons-material/MergeType';
import { useDispatch } from 'react-redux';
import { openSnackbar } from '../../AppSnackbar/snackbarSlice';
import { mergeExperts, mergeJournalists } from '../contactsRequest';
import ContactFuzzySearch from '../ContactFuzzySearch';

function MergeContactPersonnelModal(props) {
  const { units } = props;
  const { category } = props;
  const { openMergeContact, setOpenMergeContact, selectedContact, setRefreshContacts, setOpenAddContact } = props;
  const [contacts, setContacts] = useState([]);
  const [mergingContacts, setMergingContacts] = useState([]);
  const [query, setQuery] = useState('');

  const dispatch = useDispatch();

  const handleClose = (backToContactPage) => {
    setOpenMergeContact(false);
    if (backToContactPage) setOpenAddContact(false);
  };

  const handleMerge = async () => {
    let mergeContacts;
    switch (category) {
      case 'Journalists':
        mergeContacts = mergeJournalists;
        break;
      case 'Experts':
        mergeContacts = mergeExperts;
        break;
      case 'Community Members':
        mergeContacts = mergeCommunityMembers;
        break;
      default:
        mergeContacts = mergeJournalists;
        break;
    }

    const res = await mergeContacts(mergingContacts, selectedContact);
    // dispatch(openSnackbar({ severity: 'success', message: 'Contact Merged!' }));
    if (res.status === 200) {
      dispatch(openSnackbar({ severity: 'success', message: 'Contact Personnel Merged!' }));
      handleClose(true);
      setRefreshContacts(true);
    } else {
      dispatch(openSnackbar({ severity: 'error', message: 'Contact Personnel Merge Failed!' }));
    }
  };

  useEffect(() => {
    let isMounted = true;
    let getContacts;
    switch (category) {
      case 'Journalists':
        getContacts = getJournalists;
        break;
      case 'Experts':
        getContacts = getExperts;
        break;
      case 'Community Members':
        getContacts = getCommunityMembers;
        break;
      default:
        getContacts = getJournalists;
        break;
    }

    getContacts().then((response) => {
      if (isMounted) {
        setContacts(response.data);
      }
    });

    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [category]);

  return (
    <Dialog
      open={openMergeContact}
      onClose={handleClose}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
      data-cy="dialog-MergeContactPersonnelModal"
    >
      <DialogTitle>Merge Contact</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          {'Please select which contact(s) to merge into:'}
          <strong> {selectedContact?.name}</strong>
        </Typography>
        <Typography variant="body1">
          Selected to become above:
          <strong>{mergingContacts.map((contact) => contact.name).join()}</strong>
        </Typography>
        <Box
          sx={{
            marginBottom: '10px',
            marginTop: '10px',
          }}
        >
          <ContactFuzzySearch
            contacts={contacts}
            setSearchResults={setContacts}
            query={query}
            setQuery={setQuery}
            category={category}
            units={units}
          />
        </Box>
        <Box
          sx={{
            height: '50vh',
          }}
        >
          <ContactPersonnelList
            data={contacts}
            category={category}
            units={units}
            isMerging={true}
            selectedContact={selectedContact}
            mergingContacts={mergingContacts}
            setMergingContacts={setMergingContacts}
          />
        </Box>
        <DialogActions>
          <br></br>
          <Button onClick={handleClose} variant="contained" data-cy="cancel-button-MergeContactPersonnelModal">
            Cancel
          </Button>
          <Button
            onClick={handleMerge}
            startIcon={<MergeIcon />}
            variant="contained"
            data-cy="merge-button-MergeContactPersonnelModal"
          >
            Merge
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}

export default MergeContactPersonnelModal;
